<template>
  <div class="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.app {
  width: 100%;
  height: 100%;
  background-color: #F2F4F8;
}
* {
  box-sizing: border-box;
}
ul,
li {
  margin: 0;
  padding: 0;
}
</style>
